export default __webpack_public_path__ + "static/media/hero-right2.ed676656.png";